module.exports = __webpack_public_path__ + "static/media/bpharm5.f530f226.jpg";